function PodcastSVG() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4524 14.4093C11.4194 15.6712 11.2849 16.918 10.8738 18.1224C10.6809 18.6875 10.423 19.2212 9.96626 19.6378C9.43689 20.1208 8.99682 20.1255 8.46428 19.6255C7.89801 19.0942 7.62856 18.3974 7.43253 17.6803C7.05475 16.2978 6.95197 14.8791 6.97856 13.4565C7.00078 12.2676 8.0234 11.3208 9.2107 11.3136C10.3714 11.3065 11.3456 12.1815 11.4476 13.3446C11.4786 13.697 11.4524 14.0541 11.4524 14.4093Z"
        fill="#E56A17"
      />
      <path
        d="M6.96194 8.47953C6.95599 7.23111 8.02027 6.21921 9.32543 6.2323C10.4623 6.24381 11.485 7.28389 11.4965 8.44064C11.5088 9.65135 10.4675 10.6736 9.21948 10.6764C7.98892 10.6791 6.96789 9.68508 6.96194 8.47913V8.47953Z"
        fill="#E56A17"
      />
      <path
        d="M18.5227 8.10335C18.0544 3.40613 13.7167 -0.203397 8.78337 0.00890446C3.91432 0.218825 -0.0134574 4.24263 3.46554e-05 9.05533C0.0135267 13.8407 3.63813 16.9736 6.37265 17.6407C6.28694 17.2331 6.21511 16.8236 6.15718 16.4125C6.04924 16.2756 5.8917 16.166 5.67583 16.0649C2.61194 14.6276 0.803209 11.1942 1.33813 7.92676C2.07345 3.4339 6.33258 0.550174 10.9354 1.42875C15.1945 2.24144 18.0798 6.57002 17.1139 10.7014C16.5151 13.2617 14.9917 15.1018 12.5754 16.2442C12.4818 16.2883 12.3635 16.303 12.2945 16.3835C12.2354 16.8283 12.16 17.2708 12.0651 17.7105C15.2175 16.9228 19.0488 13.3839 18.5227 8.10335Z"
        fill="#E56A17"
      />
      <path
        d="M15.13 7.77875C14.4451 4.98788 11.8613 3.11764 8.84786 3.20614C6.10817 3.28669 3.65857 5.39304 3.14944 8.09225C2.61175 10.9426 4.37405 13.4256 5.95936 14.1629C5.93952 13.6621 5.93397 13.1605 5.94032 12.6585C5.91651 12.6236 5.88675 12.5887 5.84944 12.553C4.93675 11.6752 4.46056 10.6081 4.37405 9.35772C4.16571 6.35375 7.17246 3.82161 10.1752 4.49225C12.0419 4.90891 13.3244 5.99344 13.8598 7.79383C14.4042 9.62479 13.9308 11.2383 12.5328 12.5823C12.5213 12.5934 12.5086 12.6038 12.4955 12.6141C12.507 13.0192 12.484 13.4268 12.484 13.8327C12.4812 13.9438 12.4776 14.0545 12.4736 14.1653C14.3106 13.1926 15.8137 10.5641 15.13 7.77875Z"
        fill="#E56A17"
      />
    </svg>
  );
}

export { PodcastSVG };
